import Firebase from 'firebase/app';
import 'firebase/firestore';
import 'firebase/auth';

// 1) when seeding the database you'll have to uncomment this!
// import { seedDatabase } from '../seed';

const config = {
  apiKey: 'AIzaSyCQT9BnG7cd_lR7mIn66WabrO5dgTj71Nw',
  authDomain: 'portfolio-netflix.firebaseapp.com',
  projectId: 'portfolio-netflix',
  storageBucket: 'portfolio-netflix.appspot.com',
  messagingSenderId: '300909790033',
  appId: '1:300909790033:web:3ac3dc8e04e04b9e2e8970',
  measurementId: 'G-4T0GWNTT0J',
};

const firebase = Firebase.initializeApp(config);
// 2) when seeding the database you'll have to uncomment this!
// seedDatabase(firebase);
// 3) once you have populated the database (only run once!), re-comment this so you don't get duplicate data

export { firebase };
